var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('div',{staticClass:"headline-publish-date"},[_vm._v(" "+_vm._s(_vm._f("formatDateWithTime")(_vm.date))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }